export default "__VITE_ASSET__FQyPT3TM__"